import Axios from "../redux/setupAxios";
import { microserviceNames, Urls } from "../app/utils/constants";
import { InstitutionVoens } from "app/modules/Authentication/constants";
// import axios from 'axios';

const proxyName = microserviceNames.taxesMicroserviceProxy;

const options = {
  headers: {
    // "Content-Type": "multipart/form-data",
    // "X-Bridge-Authorization":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJvcmdhbml6YXRpb24iOiJEMzMyNkJBNS0zNTNGLTRBQjYtQjNBRi1BQjI1QTVBQjdEQjciLCJzaG9ydF9uYW1lIjoidG91cmlzbV90ZXN0IiwiaWRlbnRpdHkiOiI5OTFFQUNEQS1EOUVDLTRDOUItODU0Ni1GRkNERjc2NUY4MjgiLCJleHBpcmUiOjE2MzIxMjU0MDIsInZlcnNpb24iOjF9.rmyDCdIJT5KcKnB-MQTFg8rMBgBLWYZ9Hgc6b8HuT3w",
  },
};

export async function getTaxesPayer(body) {
  const voen = body?.voenOrPin;
  const voenList = Object.values(InstitutionVoens).filter((item) => item);
  if (voen && voenList.includes(voen)) {
    return {};
  } else {
    return await Axios.post(
      `${proxyName}/getTaxPayerFromTaxesSecurityService`,
      body,
      options
    );
  }
}

export async function getTaxesObject(body) {
  const voen = body?.voenOrPin;
  const voenList = Object.values(InstitutionVoens).filter((item) => item);
  if (voen && voenList.includes(voen)) {
    return {};
  } else {
    return await Axios.post(
      `${proxyName}/getObjectFromTaxesSecurityService`,
      body,
      options
    );
  }
}
